import * as React from 'react';

import * as styles from './NewbuildingAdvantagesContainer.css';

interface INewbuildingAdvantagesContainerProps {
  specifications: React.ReactNode;
  banner: React.ReactNode;
  advantages: React.ReactNode;
  detailsButton: React.ReactNode;
}

export const NewbuildingAdvantagesContainer = ({
  specifications,
  banner,
  advantages,
  detailsButton,
}: React.PropsWithChildren<INewbuildingAdvantagesContainerProps>) => {
  return (
    <div className={styles['container']}>
      <div className={styles['inline-padding-wrapper']}>{specifications}</div>
      {banner}
      {advantages}
      <div className={styles['inline-padding-wrapper']}>{detailsButton}</div>
    </div>
  );
};
